export const TITLE = "תקנון";
export const UPDATED_AT = `נכון ל -`;
